import { SimNaoEnum } from 'components/form'

import { isAllFilled } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta15Model,
  ConsultaSeguimentoPergunta15TentaImitarEnum,
} from './model-consultaSeguimentoPergunta15'

const consultaSeguimentoPergunta15TentaImitarEnumValues = Object.values(ConsultaSeguimentoPergunta15TentaImitarEnum)

export function isPergunta15TentaImitarAllFilled(
  value: ConsultaSeguimentoPergunta15Model['PERGUNTA_15_TENTA_IMITAR']
): boolean {
  return isAllFilled(value, consultaSeguimentoPergunta15TentaImitarEnumValues)
}

export function hasPergunta15TentaImitarAtLeastTwoSim(
  value: ConsultaSeguimentoPergunta15Model['PERGUNTA_15_TENTA_IMITAR']
): boolean {
  return Object.values(value ?? {}).filter((item) => item === SimNaoEnum.SIM).length >= 2
}
